<ion-card class="ion-no-padding" (click)="changeDate()">
    <ion-card-content>
        <ion-label>
            {{ document.scheduledDate | date: 'dd/MM/yyyy HH:mm'}}
            <!--            <ion-datetime display-format="DD/MM/YYYY" [(ngModel)]="document.scheduledDate"></ion-datetime>-->
        </ion-label>
    </ion-card-content>
</ion-card>
